import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectCurrentUser } from '../../auth/authSlice';
import { hasModuleFeature } from '../../auth/moduleFeatures';

export function RequireLeadsFeature() {
  const user = useSelector(selectCurrentUser);
  if (!hasModuleFeature(user, 'leads')) {
    return <Navigate to='/' replace />;
  }
  return <Outlet />;
}
